<template>
    <Layout>
        <PageHeader :title="$t('module.catalogCategory')" :items="crumbs" />
        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between mb-3"><b-input-group class="search-box"><b-form-input
                            v-model.trim="searchText" :placeholder="$t('label.search')" @keyup.enter="search" />
                        <b-input-group-append><b-button variant="info" @click="search"><i
                                    class="mdi mdi-magnify"></i></b-button></b-input-group-append></b-input-group>
                    <b-button variant="info" @click="open()"><i class="mdi mdi-plus mr-1"></i>{{ $t('label.createX',
                        [$t('module.catalogCategory')]) }}</b-button>
                </div>
                <div v-if="!status.list" class="text-center p-5"><b-spinner variant="info" /></div>
                <template v-else><b-table :items="rows" :fields="fields" show-empty responsive>
                        <template #cell(isActive)="{ item }"><b-form-checkbox :checked="item.isActive" switch
                                :disabled="!status.save" @change="changeStatus(item, $event)">{{ item.isActive ?
                                    $t('label.active') : $t('label.inactive') }}</b-form-checkbox></template>
                        <template #cell(actions)="{ item }"><a href="javascript:void(0)" class="text-info"
                                @click="open(item)"><i class="mdi mdi-pencil-outline font-size-18"></i></a><a
                                href="javascript:void(0)" class="text-danger ml-2" @click="remove(item)"><i
                                    class="mdi mdi-delete-outline font-size-18"></i></a></template>
                    </b-table>
                    <div v-if="pagination.total" class="d-flex justify-content-between"><small>{{ $tc('label.results',
                        pagination.total,
                        [pagination.total]) }}</small><b-pagination v-model="page" :total-rows="pagination.total"
                            :per-page="filter.pageSize" @change="go" /></div>
                </template>
            </div>
        </div><b-modal id="catalog-category-form"
            :title="$t(selected.uuid ? 'label.updateX' : 'label.createX', [$t('module.catalogCategory')])" size="lg"
            hide-footer hide-header-close @hidden="close">
            <CatalogCategoryForm v-if="visible" :category-u-u-i-d="selected.uuid" :search-criteria="filter"
                @done="close" />
        </b-modal>
    </Layout>
</template>
<script>
import { mapState } from 'vuex'; import Layout from '@/views/layouts/main'; import PageHeader from '@/components/page-header'; import i18n from '@/i18n';
import { catalogCategoryMethods } from '@/state/api'; import { CATALOG_CATEGORY_MODULE } from '@/state/api/catalogCategory.state'; import CatalogCategoryForm from './form';
const defaults = () => ({ pageNumber: 1, pageSize: 15, searchArray: [], sortBy: 'created_at', orderBy: 'desc' });
export default {
    name: 'CatalogCategoryListing', page: { title: i18n.t('module.catalogCategory') }, components: { Layout, PageHeader, CatalogCategoryForm },
    data() {
        return {
            searchText: '', page: 1, visible: false, selected: { uuid: '' }, filter: defaults(),
            crumbs: [{ text: i18n.t('module.communication'), href: '/communications' }, { text: i18n.t('module.catalogCategory'), active: true }],
            fields: [
                { key: 'name', label: i18n.t('label.name') },
                { key: 'isActive', label: i18n.t('label.status') },
                { key: 'updatedAt', label: i18n.t('label.updatedAt') },
                { key: 'actions', label: i18n.t('label.action') }
            ]
        };
    },
    computed: {
        ...mapState(CATALOG_CATEGORY_MODULE, ['status']),
        rows() {
            return this.$store.state.api.catalogCategory.list.data || [];
        },
        pagination() {
            return this.$store.state.api.catalogCategory.list.pagination || {};
        }
    },
    created() {
        this.load();
    },
    methods: {
        ...catalogCategoryMethods,
        load() {
            return this.getAllCatalogCategory({ filter: this.filter });
        },
        search() {
            this.page = 1;
            this.filter = {
                ...this.filter,
                pageNumber: 1,
                searchArray: this.searchText ? [this.searchText] : []
            };
            this.load();
        },
        go(pageNumber) {
            this.page = pageNumber;
            this.filter = { ...this.filter, pageNumber };
            this.load();
        },
        open(item = null) {
            this.selected = { uuid: item?.uuid || '' };
            this.visible = true;
            this.$nextTick(() => this.$bvModal.show('catalog-category-form'));
        },
        close() {
            this.$bvModal.hide('catalog-category-form');
            this.visible = false; this.selected = { uuid: '' };
        },
        async changeStatus(item, isActive) {
            const action = this.$t(isActive ? 'label.activate' : 'label.deactivate');
            const ok = await this.$bvModal.msgBoxConfirm(this.$t('label.confirmChangeStatusX', [action, item.name]), { title: this.$t('label.confirmStatusChange'), centered: true });
            if (ok) { await this.updateCatalogCategoryStatus({ uuid: item.uuid, isActive, filter: this.filter }); }
        },
        async remove(item) {
            const ok = await this.$bvModal.msgBoxConfirm(this.$t('label.confirmDeleteX', [item.name]), { title: this.$t('label.confirmDelete'), okTitle: this.$t('label.delete'), okVariant: 'danger', centered: true });
            if (ok) { await this.deleteCatalogCategory({ uuid: item.uuid, filter: this.filter }); }
        },
    },
};
</script>
<style scoped>
.search-box {
    max-width: 420px;
}
</style>
